import React, { useState } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Appearance() {
  const [theme, setTheme] = useState("light");
  const [sidebarSize, setSidebarSize] = useState("");
  const [fontFamily, setFontFamily] = useState("");

  const themes = ["light", "dark", "auto"];

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Appearance
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0 p-4"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        {/* THEME SECTION */}
        <motion.div
          className="mb-4"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <label className="form-label fw-medium">Select Theme</label>

          <div className="d-flex gap-4 mt-2">
            {themes.map((item, i) => (
              <motion.div
                key={item}
                onClick={() => setTheme(item)}
                style={{
                  width: 90,
                  cursor: "pointer",
                  textAlign: "center",
                }}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {/* PREVIEW BOX */}
                <motion.div
                  style={{
                    height: 60,
                    borderRadius: 6,
                    border: "2px solid",
                    borderColor: theme === item ? "#0d6efd" : "#ddd",
                    background:
                      item === "light"
                        ? "#f8f9fa"
                        : item === "dark"
                        ? "#343a40"
                        : "linear-gradient(90deg,#f8f9fa 50%,#343a40 50%)",
                  }}
                  animate={{
                    scale: theme === item ? 1.05 : 1,
                  }}
                />

                <small className="text-capitalize d-block mt-1">
                  {item === "auto" ? "Automatic" : item}
                </small>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* SIDEBAR SIZE */}
        <motion.div
          className="row align-items-center mb-3"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <label className="col-sm-3 fw-medium">Sidebar Size</label>

          <div className="col-sm-4">
            <motion.select
              className="form-select"
              value={sidebarSize}
              onChange={(e) => setSidebarSize(e.target.value)}
              whileFocus={{ scale: 1.02 }}
            >
              <option value="">--- Select ---</option>
              <option value="small">Small</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
            </motion.select>
          </div>
        </motion.div>

        {/* FONT FAMILY */}
        <motion.div
          className="row align-items-center mb-3"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35 }}
        >
          <label className="col-sm-3 fw-medium">Font Family</label>

          <div className="col-sm-4">
            <motion.select
              className="form-select"
              value={fontFamily}
              onChange={(e) => setFontFamily(e.target.value)}
              whileFocus={{ scale: 1.02 }}
            >
              <option value="">--- Select ---</option>
              <option value="poppins">Poppins</option>
              <option value="roboto">Roboto</option>
              <option value="inter">Inter</option>
            </motion.select>
          </div>
        </motion.div>

        {/* BUTTONS */}
        <motion.div
          className="d-flex justify-content-end mt-4 gap-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.45 }}
        >
          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-danger"
          >
            Cancel
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-primary"
          >
            Save
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
} 